<template>
  <div class="up-to-date">
    <i-icon :icon="status.icon" type="far"></i-icon>
    <span :style="{ 'color': status.color }"><strong>{{ status.text }}</strong></span>
    <slot></slot>
    <i-dropdown>
      <template v-slot:trigger="{toggle, attrs}">
          <a
              @click="toggle"
              v-bind="attrs"
              aria-haspopup='true'
          >
            <i class="fa5 far fa-caret-square-down"></i>
          </a>
      </template>
      <i-menu-list class="pull-left overflow-y-auto">
          <i-menu-action v-if="upToDate"
            :label="LANG.republish"
            :icon="'sync'"
            @click.prevent="() => publish()"
          />
          <i-menu-action v-if="upToDate"
            :label="LANG.unpublish"
            :icon="'download'"
            @click.prevent="() => unpublish()"
          />
          <i-menu-action v-else
            :label="LANG.publish"
            :icon="'globe'"
            @click.prevent="() => publish()"
          />
          <i-menu-action v-if="canReimport"
            :label="LANG.reimport"
            :icon="'pen-square'"
            @click.prevent="() => reimport()"
          />
      </i-menu-list>
    </i-dropdown>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import globals from '@/globals';
import LANG from '@/lang/eng';

import Icon from '@/components/lib/icon/Icon.vue';

const STATUS_MAPPING = {
  published: {
    text: LANG.published,
    icon: 'check-circle',
    color: 'green',
  },
  updateScheduled: {
    text: LANG.updateScheduled,
    icon: 'sync-alt',
    color: 'blue',
  },
  updateAvailable: {
    text: LANG.updateAvailable,
    icon: 'hourglass',
    color: 'blue',
  },
  notPublished: {
    text: LANG.notPublished,
    icon: 'circle',
    color: 'gray',
  },
};

export default defineComponent({
  components: {
    [Icon.name]: Icon,
  },
  props: {
    onLive: Number,
    outdated: Number,
    publishDate: String,
    publishUri: String,
    canReimport: Boolean,
    nodeId: String,
  },
  computed: {
    ...mapState(['LANG']),
    upToDate() {
      return !!this.onLive;
    },
    status() {
      if (!this.onLive) {
        return STATUS_MAPPING.notPublished;
      }

      if (this.outdated) {
        if (this.publishDate) {
          return STATUS_MAPPING.updateScheduled;
        }

        return STATUS_MAPPING.updateAvailable;
      }

      return STATUS_MAPPING.published;
    },
  },
  methods: {
    publish() {
      const { nodeId } = this; // eslint-disable-line
      const uri = globals.I.Util.uri('/document/publisher' + `?publish_job=/publish${nodeId}/uri:${this.publishUri}`); // eslint-disable-line
      globals.context.open(uri, '_blank');
    },
    unpublish() {
      const { nodeId } = this; // eslint-disable-line
      const uri = globals.I.Util.uri('/document/publisher' + `?publish_job=/unpublish${nodeId}/uri:${this.publishUri}`); // eslint-disable-line
      globals.context.open(uri, '_blank');
    },
    reimport() {
      const { nodeId } = this; // eslint-disable-line
      const uri = globals.I.Util.uri('/document/archive/import' + `?__imperia_node_id=${nodeId}`); // eslint-disable-line
      globals.context.open(uri, '_blank');
    },
  },
});
</script>

<style scoped lang='scss'>
.up-to-date {
  display: flex;
  align-items: center;

  span {
    margin-right: 5px;
  }

  i {
    margin-right: 5px;
    color: $blue;
  }
}

.fa-check-square {
  color:#26BF4B;
}
.fa-exclamation-circle {
  color: $red;
}
</style>
